import { render, staticRenderFns } from "./donutSectionLeft.vue?vue&type=template&id=25aae8c8&"
import script from "./donutSectionLeft.vue?vue&type=script&lang=js&"
export * from "./donutSectionLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports